import { render, staticRenderFns } from "./test-canvas-talent.vue?vue&type=template&id=f50675c8&scoped=true&"
import script from "./test-canvas-talent.vue?vue&type=script&lang=js&"
export * from "./test-canvas-talent.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas-talent.vue?vue&type=style&index=0&id=f50675c8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50675c8",
  null
  
)

export default component.exports